module.exports = __webpack_public_path__ + "img/ask.2d9f661f.svg";